import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en, de, nl, pt, it, fr } from '../../locales/index.js';
import CookieStorage from "../utils/cookie";
import queryString from 'query-string';
import LanguageService from "../services/language-service";

const resources = {
    en: { translation: {...en} }, 
    de: { translation: {...de} }, 
    nl: { translation: {...nl} }, 
    pt: { translation: {...pt} }, 
    it: { translation: {...it} }, 
    fr: { translation: {...fr} }
};

let language = 'en'

let params = queryString.parse(location.search)
let paramsLocale = params.locale
if (paramsLocale) { language = paramsLocale }

let cookieLanguage = CookieStorage.getCookie("language")
if (cookieLanguage) { language = cookieLanguage}

if (!cookieLanguage && paramsLocale) {
    LanguageService.changeLanguage(paramsLocale).then(res =>{});
}

let paramsForceLocale = params.force_locale
if (paramsForceLocale) {
    language = paramsForceLocale
    LanguageService.changeLanguage(paramsForceLocale).then(res =>{});
}

i18n.use(initReactI18next)
  .init({
    resources,
    lng: language,
    fallbackLng: "en",

    keySeparator: '.',

    interpolation: {
        escapeValue: false
    },

    react: {
        useSuspense: true,
    }
  });

export default i18n;
